import { ModalSaveComponent } from './../shared/modals/modal-save/modal-save.component';
import { ModalContactComponent } from './../shared/modals/modal-contact/modal-contact.component';
import { ModalStartScreenComponent } from './../shared/modals/modal-start-screen/modal-start-screen.component';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TourNavigationService } from '../services/tour-navigation.service';
import { AuthService } from '../services/auth.service';
import { ModalShareEmailComponent } from '../shared/modals/modal-share-email/modal-share-email.component';
import { PdfService } from '../services/pdf.service';
import { ProjectManagerService } from '../services/project-manager.service';
import { ToasterService } from 'angular2-toaster';
import { DrawTitleBlockComponent } from '../services/proTools/components/DrawTitleBlockComponent';
import { Subscription } from 'rxjs';
import { GetQuoteService } from '../shared/modals/modal-get-quote/services/get-quote.service';
import {ModalPrintComponent} from "../shared/modals/modal-print/modal-print.component";
import { SceneLoadingService } from '../services/scene-loading.service';

@Component({
  selector: 'app-footer-toolbar',
  templateUrl: './footer-toolbar.component.html',
  styleUrls: ['./footer-toolbar.component.scss']
})
export class FooterToolbarComponent implements OnInit {
  tourStep: number;
  private isProjectSaved: boolean = false;
  openSaveDialogSubscribtion: Subscription;
  isSceneLoaded: boolean = false;
  private tooltipElement: HTMLElement | null = null;

  constructor(
    public dialog: MatDialog,
    public tourNavigationService: TourNavigationService,
    private pdfService: PdfService,
    private projectSrvc: ProjectManagerService,
    private toasterService: ToasterService,
    private drawTitleBlock: DrawTitleBlockComponent,
    private getQuoteService: GetQuoteService,
    private sceneLoadingService: SceneLoadingService
  ) {}

  private _showToast(type: string, title: string, body: string) {
    this.toasterService.popAsync(type, title, body);
  }

  private createTooltipInBody(): void {
    if (this.tooltipElement) {
      return;
    }

    this.tooltipElement = document.createElement('div');
    this.tooltipElement.className = 'body-tooltip';
    this.tooltipElement.style.cssText = `
      position: fixed;
      background-color: rgba(0, 0, 0, 0.9);
      color: white;
      padding: 10px 14px;
      border-radius: 6px;
      font-size: 12px;
      white-space: nowrap;
      z-index: 999999 !important;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
      pointer-events: auto;
      transform-style: preserve-3d;
      backface-visibility: hidden;
      will-change: transform, opacity;
      transform: translateX(-50%);
    `;

    // Add arrow
    this.tooltipElement.innerHTML = `
      <div>${this.isSceneLoaded ? 'Click to get a quote for your project' : 'Please select a starting deck shape and railing options before requesting a quote.'}</div>
      <div style="
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border: 6px solid transparent;
        border-top-color: rgba(0, 0, 0, 0.9);
        margin-left: 0;
      "></div>
    `;

    document.body.appendChild(this.tooltipElement);
  }

  public showTooltipInBody(event: MouseEvent): void {
    this.createTooltipInBody();
    this.updateTooltipContent(); // Update content before showing
    
    if (this.tooltipElement) {
      const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
      
      // Position tooltip at the center of the button
      const tooltipLeft = rect.left + (rect.width / 2);
      this.tooltipElement.style.left = tooltipLeft + 'px';
      
      // Position tooltip above the button
      const tooltipBottom = window.innerHeight - rect.top + 12;
      this.tooltipElement.style.bottom = tooltipBottom + 'px';
      
      // Add transform for centering
      this.tooltipElement.style.transform = 'translateX(-50%)';
      
      this.tooltipElement.style.opacity = '1';
      this.tooltipElement.style.visibility = 'visible';
      
      // Add event handlers for tooltip so it doesn't disappear when hovering over it
      this.tooltipElement.addEventListener('mouseenter', this.handleTooltipMouseEnter);
      this.tooltipElement.addEventListener('mouseleave', this.handleTooltipMouseLeave);
      
      // Add click handler for link only if scene is not loaded
      if (!this.isSceneLoaded) {
        setTimeout(() => {
          if (this.tooltipElement) {
            const linkElement = this.tooltipElement.querySelector('.tooltip-link');
            if (linkElement) {
              // Remove old handlers before adding new one
              linkElement.removeEventListener('click', this.handleTooltipLinkClick);
              linkElement.addEventListener('click', this.handleTooltipLinkClick);
            }
          }
        }, 100);
      }
    }
  }

  private hideTooltipTimeout: any = null;

  public hideTooltipInBody(event?: MouseEvent): void {
    if (this.tooltipElement) {
      // Clear previous timer
      if (this.hideTooltipTimeout) {
        clearTimeout(this.hideTooltipTimeout);
      }
      
      // Use delay to give time for cursor to move to tooltip
      this.hideTooltipTimeout = setTimeout(() => {
        if (this.tooltipElement) {
          this.tooltipElement.style.opacity = '0';
          this.tooltipElement.style.visibility = 'hidden';
          
          // Remove event handlers
          this.tooltipElement.removeEventListener('mouseenter', this.handleTooltipMouseEnter);
          this.tooltipElement.removeEventListener('mouseleave', this.handleTooltipMouseLeave);
        }
      }, 100); // 100ms delay
    }
  }

  private updateTooltipContent(): void {
    if (this.tooltipElement) {
      if (this.isSceneLoaded) {
        const tooltipText = 'Click to get a quote for your project';
        const tooltipContent = this.tooltipElement.querySelector('div:first-child');
        if (tooltipContent) {
          tooltipContent.textContent = tooltipText;
        }
      } else {
        // Create clickable text for inactive state
        const tooltipContent = this.tooltipElement.querySelector('div:first-child');
        if (tooltipContent) {
          tooltipContent.innerHTML = `
            Please <span class="tooltip-link" style="color: #4CAF50; text-decoration: underline; cursor: pointer;">select a starting deck shape and railing options</span> before requesting a quote.
          `;
        }
      }
    }
  }

  private openStartScreenModal(): void {
    const dialogRef = this.dialog.open(ModalStartScreenComponent, {
      width: '835px',
      height: '75vh',
      disableClose: false,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Start screen modal closed');
    });
  }

  private handleTooltipLinkClick = (event: Event): void => {
    event.stopPropagation();
    
    // Hide tooltip before opening modal window
    if (this.tooltipElement) {
      this.tooltipElement.style.opacity = '0';
      this.tooltipElement.style.visibility = 'hidden';
      
      // Remove event handlers
      this.tooltipElement.removeEventListener('mouseenter', this.handleTooltipMouseEnter);
      this.tooltipElement.removeEventListener('mouseleave', this.handleTooltipMouseLeave);
    }
    
    // Clear hide timer
    if (this.hideTooltipTimeout) {
      clearTimeout(this.hideTooltipTimeout);
      this.hideTooltipTimeout = null;
    }
    
    this.openStartScreenModal();
  }

  private handleTooltipMouseEnter = (event: Event): void => {
    // Cancel hide timer when hovering over tooltip
    if (this.hideTooltipTimeout) {
      clearTimeout(this.hideTooltipTimeout);
      this.hideTooltipTimeout = null;
    }
    
    // Keep tooltip visible when hovering over it
    if (this.tooltipElement) {
      this.tooltipElement.style.opacity = '1';
      this.tooltipElement.style.visibility = 'visible';
    }
  }

  private handleTooltipMouseLeave = (event: Event): void => {
    // Hide tooltip when mouse leaves it
    if (this.tooltipElement) {
      this.tooltipElement.style.opacity = '0';
      this.tooltipElement.style.visibility = 'hidden';
      
      // Remove event handlers
      this.tooltipElement.removeEventListener('mouseenter', this.handleTooltipMouseEnter);
      this.tooltipElement.removeEventListener('mouseleave', this.handleTooltipMouseLeave);
    }
  }


  openSaveDialog(): void {
    let dialogRef = this.dialog.open(ModalSaveComponent, {
      width: '455px',
      data: 'Data'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Save/Rename dialog was closed');
    });
  }

  openContactDialog(): void {
    const project = this.projectSrvc.getCurrentProject();
    if (!project.tiers && !project.projectType && project.deckHeight === undefined) {
      this._showToast('warning', 'Project not created', 'Please create your project');
      return;
    }
    let dialogRef = this.dialog.open(ModalContactComponent, {
      width: '508px',
      data: 'Data'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Contact dialog was closed');
    });
  }

  openGetAQuoteDialog(): void {
    // Check if scene is loaded
    if (!this.isSceneLoaded) {
      this._showToast('warning', 'Scene not loaded', 'Please select a scene first');
      return;
    }

    // If logged in
    // 1. resaving or create a new project?
    // if resaving - silently resave, if a new project - show the new project
    // dialog with 'save' button
    // 2. open a dialog box to submit user info,
    // project URL and user comments to Feeney through NetSuite
    // 3. show closest 5 NetSuite dealers, by zip code search

    // If not logged in
    // 1. open new account signup (or login?)
    // on signup (login) dialog add project name
    // and send all data to the server
    // 2. open a dialog box to submit user info,
    // project URL and user comments to Feeney through NetSuite
    // 3. show closest 5 NetSuite dealers, by zip code search

    // const project = this.projectSrvc.getCurrentProject();
    // if (!project.tiers && !project.projectType && project.deckHeight === undefined) {
    //   this._showToast('warning', 'Project not created', 'Please create your project');
    //   return;
    // }
    // let dialogRef = this.dialog.open(ModalContactComponent, {
    //   width: '508px',
    //   data: 'Data'
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   // console.log('Contact dialog was closed');
    // });
    this.getQuoteService.getQuote().subscribe();
  }

  openShareDialog(): void {
    const shareDialog = this.dialog.open(ModalShareEmailComponent, {
      width: '500px',
      data: 'shareProject'
    });

    shareDialog.afterClosed().subscribe(result => {
      // console.log('Share dialog was closed');
    });
  }

  openPrintDialog(): void {
    if (!this.isProjectSaved) {
      const printDialog = this.dialog.open(ModalPrintComponent, {
        width: '500px',
        data: 'printProject'
      });
    } else {
      this.pdfService.printProject();
    }

    // if (!this.isProjectSaved) {
    //   this.showToast('warning', 'Warning', 'Print function is available for saved projects only');
    // } else {
    //   this.pdfService.printProject();
    // }
  }

  private showToast(type: string, title: string, body: string) {
    this.toasterService.popAsync(type, title, body);
  }

  ngOnInit() {
    this.openSaveDialogSubscribtion = this.drawTitleBlock.openSaveDialogSubscribtion.subscribe(
      value => {
        if (value) {
          this.openSaveDialog();
        }
      }
    );
    this.tourNavigationService.Navigator.subscribe(value => {
      this.tourStep = value;
    });
    this.projectSrvc.isSavedProject.subscribe(value => (this.isProjectSaved = value));
    
    // Subscribe to scene loading state
    this.sceneLoadingService.isSceneLoaded$.subscribe(isLoaded => {
      this.isSceneLoaded = isLoaded;
      this.updateTooltipContent(); // Update tooltip content when state changes
    });
  }

  ngOnDestroy() {
    this.openSaveDialogSubscribtion.unsubscribe();
    if (this.hideTooltipTimeout) {
      clearTimeout(this.hideTooltipTimeout);
    }
    if (this.tooltipElement) {
      document.body.removeChild(this.tooltipElement);
      this.tooltipElement = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/footer-toolbar/footer-toolbar.component.ts